/* eslint-disable class-methods-use-this, prefer-destructuring, no-use-before-define, no-shadow */
class Header {
	constructor() {
		this.header = document.getElementById("header");
		if (this.header) {
			this.initHeader();
			this.searchForm();
		}
	}

	initHeader() {
		const header = this.header;
		const headerHeight = header.offsetHeight + 60;
		let distanceToTop = document.documentElement.scrollTop;

		// Menu button event listener
		const mobileMenuToogler = document.getElementById("main-menu-toggler");
		if (mobileMenuToogler) {
			mobileMenuToogler.addEventListener("click", blockScroll);
		}

		// Scroll event listener
		window.addEventListener("scroll", throttle(callback, 200));

		if (distanceToTop > 0) {
			header.classList.add("scrolled");
		}

		function blockScroll() {
			const body = document.body;
			if (!this.classList.contains("menu-item-has-children")) {
				if (body.classList.contains("u-mobile-block-scroll")) {
					document.body.classList.remove("u-mobile-block-scroll");
				} else {
					document.body.classList.add("u-mobile-block-scroll");
				}
			}
		}

		function throttle(callback, wait = 100) {
			let timer = null;

			return (args) => {
				if (timer === null) {
					timer = setTimeout(() => {
						callback.apply(this, args);
						timer = null;
					}, wait);
				}
			};
		}

		function callback() {
			const newDistanceToTop = document.documentElement.scrollTop;

			if (newDistanceToTop > headerHeight) {
				header.classList.add("scrolled");
			}

			if (newDistanceToTop < distanceToTop) {
				header.classList.add("scrolled--show");
			} else {
				header.classList.remove("scrolled--show");
			}

			if (newDistanceToTop === 0) {
				setTimeout(() => {
					header.classList.remove("scrolled", "scrolled--show");
				}, 1000);
			}

			distanceToTop = newDistanceToTop;
		}

		// Set a CSS variable to fix Webkit-based mobile phones handling of vh units.
		// You can use it with the vh() SASS function.
		function setCSSvh() {
			document.documentElement.style.setProperty(
				"--vh",
				`${window.innerHeight}px`
			);
		}

		window.addEventListener("resize", setCSSvh);
		window.addEventListener("orientationchange", setCSSvh);
		setCSSvh();
	}

	searchForm() {
		const body = document.body;
		const header = this.header;
		const searchFormButton =
			document.getElementsByClassName("js-search-button")[0];
		const searchForm = document.getElementsByClassName(
			"search-form--header"
		)[0];
		const searchFormInput =
			document.getElementsByClassName("search-form__input")[0];

		function showSearchForm(form) {
			const searchForm = form;
			body.classList.add("searchForm");
			header.classList.add("scrolled--show");
			header.classList.add("scrolled");
			searchForm.style.display = "block";
			searchForm.setAttribute("aria-expanded", "true");
			searchFormInput.focus();
		}

		function hideSearchForm() {
			searchForm.style.display = "none";
			body.classList.remove("searchForm");
			header.classList.remove("scrolled--show");
			header.classList.remove("scrolled");
			searchForm.setAttribute("aria-expanded", "false");
		}

		function searchFormToggle(event) {
			event.preventDefault();

			if (searchForm.style.display === "block") {
				hideSearchForm();
			} else {
				showSearchForm(searchForm);
			}
		}

		// remove transitions header resize window

		const classes = header.classList;

		let timer = 0;
		window.addEventListener("resize", function () {
			if (timer) {
				clearTimeout(timer);
				timer = null;
			} else classes.add("stop-transitions");

			timer = setTimeout(() => {
				classes.remove("stop-transitions");
				timer = null;
			}, 100);
		});

		// Toggle search form
		if (searchFormButton && searchForm && searchFormInput) {
			// Toggle search form when clicking search button
			searchFormButton.addEventListener("click", searchFormToggle);

			// Hide search form when clicking outside or when tabbing or escaping out of the search bar.
			searchFormInput.addEventListener("keydown", (event) => {
				// Esc: 27.
				if (event.keyCode === 27) {
					hideSearchForm();
				}
			});
		}
	}
}

export default Header;
